import { Skeleton } from "@/components/ui/skeleton";

export function DocumentSummarySkeleton() {
  return (
    <div className="space-y-6">
      {/* Section 1 */}
      <div className="space-y-3">
        <Skeleton className="h-5 w-32" /> {/* Section header */}
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>

      {/* Section 2 */}
      <div className="space-y-3">
        <Skeleton className="h-5 w-40" /> {/* Section header */}
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>

      {/* Section 3 */}
      <div className="space-y-3">
        <Skeleton className="h-5 w-36" /> {/* Section header */}
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
      </div>
    </div>
  );
}
